import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ServiceChannel} from './service-channel.model';
import * as ServiceChannelActions from './service-channel.actions';

export const serviceChannelsFeatureKey = 'serviceChannels';

export interface State extends EntityState<ServiceChannel> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceChannel> = createEntityAdapter<ServiceChannel>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceChannelActions.addServiceChannel,
    (state, action) => adapter.addOne(action.serviceChannel, state)
  ),
  on(ServiceChannelActions.upsertServiceChannel,
    (state, action) => adapter.upsertOne(action.serviceChannel, state)
  ),
  on(ServiceChannelActions.addServiceChannels,
    (state, action) => adapter.addMany(action.serviceChannels, state)
  ),
  on(ServiceChannelActions.upsertServiceChannels,
    (state, action) => adapter.upsertMany(action.serviceChannels, state)
  ),
  on(ServiceChannelActions.updateServiceChannel,
    (state, action) => adapter.updateOne(action.serviceChannel, state)
  ),
  on(ServiceChannelActions.updateServiceChannels,
    (state, action) => adapter.updateMany(action.serviceChannels, state)
  ),
  on(ServiceChannelActions.deleteServiceChannel,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceChannelActions.deleteServiceChannels,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceChannelActions.loadServiceChannels,
    (state, action) => adapter.setAll(action.serviceChannels, state)
  ),
  on(ServiceChannelActions.clearServiceChannels,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
